import { Flex } from "@chakra-ui/react";
import { H3, BodyText2 } from "src/atoms/typography";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as SchedulerIcon } from "src/icons/clock.svg";
import { ReactComponent as WarningIcon } from "../icons/warning-small.svg";

export default function Description({ t }) {
  return (
    <Flex justifyContent="center">
      <Flex
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        maxWidth="480px"
      >
        <Flex
          bg="primaryLight"
          justifyContent="center"
          alignItems="center"
          width="40px"
          height="40px"
          borderRadius="100%"
        >
          <SvgContainer icon={SchedulerIcon} fill="primary" size="20px" />
        </Flex>
        <H3 textAlign="center" mt="16px" mb="12px">
          {t("scheduler.description.heading")}
        </H3>
        <BodyText2 textAlign="center" mb="12px">
          {t("scheduler.description.text1")}
        </BodyText2>
        <BodyText2 textAlign="center" mb="12px">
          {t("scheduler.description.text2")}
        </BodyText2>
        <BodyText2 textAlign="center" mb="24px">
          {t("scheduler.description.text3")}
        </BodyText2>
        <Flex
          p="12px"
          bg="hover"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          borderRadius="16px"
          maxWidth="320px"
        >
          <SvgContainer icon={WarningIcon} mb="8px" />
          <BodyText2 textAlign="center">
            {t("scheduler.description.warning")}
          </BodyText2>
        </Flex>
      </Flex>
    </Flex>
  );
}
